import { render, staticRenderFns } from "./StageCreation.vue?vue&type=template&id=196a11a1&scoped=true"
import script from "./StageCreation.vue?vue&type=script&lang=js"
export * from "./StageCreation.vue?vue&type=script&lang=js"
import style0 from "./StageCreation.vue?vue&type=style&index=0&id=196a11a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196a11a1",
  null
  
)

export default component.exports